/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface GetStudentBaseResponse
 */
export interface GetStudentBaseResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetStudentBaseResponse
     */
    studentId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof GetStudentBaseResponse
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof GetStudentBaseResponse
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof GetStudentBaseResponse
     */
    email: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetStudentBaseResponse
     */
    isActive: boolean;
}

/**
 * Check if a given object implements the GetStudentBaseResponse interface.
 */
export function instanceOfGetStudentBaseResponse(value: object): value is GetStudentBaseResponse {
    if (!('studentId' in value) || value['studentId'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    return true;
}

export function GetStudentBaseResponseFromJSON(json: any): GetStudentBaseResponse {
    return GetStudentBaseResponseFromJSONTyped(json, false);
}

export function GetStudentBaseResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetStudentBaseResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'studentId': ApiUserTasksGetPageParameterFromJSON(json['studentId']),
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'email': json['email'],
        'isActive': json['isActive'],
    };
}

export function GetStudentBaseResponseToJSON(json: any): GetStudentBaseResponse {
    return GetStudentBaseResponseToJSONTyped(json, false);
}

export function GetStudentBaseResponseToJSONTyped(value?: GetStudentBaseResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'studentId': ApiUserTasksGetPageParameterToJSON(value['studentId']),
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'isActive': value['isActive'],
    };
}

